import styled from "styled-components";
import Header from "./index";

export default styled(Header)`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #0ca678;

    height: 6rem;
    padding: 0 4.8rem;
  }
`;
